/**
 * Created by ObadaDarwish on 03/12/2017.
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'searchPipe'})

export class filterSearch implements PipeTransform {


  transform(searchList: any, searchValue: any, subscribe: string): any {
    if (searchList) {
      // searching for tournaments by tournament name
      if (subscribe == 'name') {
        if (searchValue) {
          return searchList.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase()));
        } else {
          return searchList;
        }
      }
      // searching for tournaments by tournament city
      else if (subscribe == 'city') {
        if (searchValue) {
          return searchList.filter(item => item.city).filter(item => item.city.toLowerCase().includes(searchValue.toLowerCase()));
        } else {
          return searchList;
        }
      }
      // searching for tournaments by tournament game
      else if (subscribe == 'game') {
        if (searchValue) {
          return searchList.filter(item => item.game.data.code.toLowerCase().includes(searchValue.toLowerCase()));
        } else {
          return searchList;
        }
      }
      // searching for gamers by participant name
      else if (subscribe == 'participant') {
        if (searchValue) {
          return searchList.filter(item => item.participant_name.toLowerCase().includes(searchValue.toLowerCase()));
        } else {
          return searchList;
        }
      }
      // searching by participant name in match list
      else if (subscribe == 'matchList') {
        if (searchValue) {
          return searchList.filter(item => {
            // if(item.home&&item.away){
            return (item.home ? item.home.data.participant_name.toLowerCase().includes(searchValue.toLowerCase()) : null) ||
              (item.away ? item.away.data.participant_name.toLowerCase().includes(searchValue.toLowerCase()) : null);
            // }
          });
        } else {
          return searchList;
        }
      }
      // searching by  in TournamentLogs
      else if (subscribe == 'Logs') {
        if (searchValue) {
          return searchList.filter(item => item.message.toLowerCase().includes(searchValue.toLowerCase()));
        } else {
          return searchList;
        }
      }

      // searching for players
      else {
        if (searchValue) {
          return searchList.filter(item => item.player ? item.player.toLowerCase().includes(searchValue.toLowerCase()) : null);
        } else {
          return searchList;
        }
      }
    }

  }
}
